export interface AddItemToBasketRequest {
  productID: number;
  quantity: number;
  optionValueID?: string;
  addedAtCheckout: boolean;
}

export const addItemToBasketRequestOutputTransformer = (
  req: AddItemToBasketRequest,
) => ({
  product_id: req.productID,
  quantity: req.quantity,
  options: req.optionValueID ? [{ valueId: req.optionValueID }] : undefined,
  added_at_checkout: req.addedAtCheckout,
});
